module.exports = __webpack_public_path__ + "static/media/gas_05.634ffa12.svg";